import { render, staticRenderFns } from "./shanxiSixDialog.vue?vue&type=template&id=1435d58a&scoped=true"
import script from "./shanxiSixDialog.vue?vue&type=script&lang=js"
export * from "./shanxiSixDialog.vue?vue&type=script&lang=js"
import style0 from "./shanxiSixDialog.vue?vue&type=style&index=0&id=1435d58a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435d58a",
  null
  
)

export default component.exports